<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Compensation Standards</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateCompensationStandard()">
        <mat-icon>add</mat-icon>
        Add Compensation Standard
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="compensationStandards()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCompensationStandard($event)"
      (deleteClick)="onDeleteCompensationStandard($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
